/**
 * Mock implementations for MFE host remote modules.
 * Used when running standalone (without the host application).
 */

// Mock for mfe/host/app-auth-provider
export const authMiddleware = () => (next: (action: unknown) => unknown) => (action: unknown) => next(action);

// Mock for mfe/host/app-sidebar
export const useSidebarApi = () => ({
    initialize: () => {},
    destroy: () => {},
});
